/** @jsxImportSource @emotion/react */

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageTemplate from '@page/iyagigo/page-template';
import GrammarStudy from '@component/iyagigo/classroom/grammar-study';
import HeaderProgress from '@component/iyagigo/common/header-progress';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as classroomActions } from '@store/slice/classroom-slice';

// 문법 학습 페이지 (/ig/classroom-grammar) — character-page 패턴 미러
const GrammarPage: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const [searchParams] = useSearchParams();
  const grammarStudyKey = [searchParams.get('language'), searchParams.get('stage'), searchParams.get('topic'), searchParams.get('grammar')].join(':');

  // 학습 진행(설명카드+퀴즈) — GrammarStudy가 onProgress로 올려줌. total>0일 때만 프로그레스바 노출
  const [progress, setProgress] = useState<{ current: number; total: number }>({ current: 0, total: 0 });

  useEffect(() => {
    dispatch(classroomActions.storeIsStudying(true));
    return () => {
      dispatch(classroomActions.storeIsStudying(false));
    };
  }, [dispatch]);

  const handleBackClick = () => {
    dispatch(
      modalActions.showDialogModal({
        type: 'workbook-quit',
        data: { mainMenu: 'classroom', subMenu: 'grammar' },
      }),
    );
  };

  return (
    <PageTemplate
      title='문법 학습'
      mode={'close'}
      handleNavigationClick={handleBackClick}
      customHeader={
        progress.total > 0 ? (
          <HeaderProgress currentProgress={progress.current} totalProgress={progress.total} />
        ) : undefined
      }>
      <GrammarStudy key={grammarStudyKey} onProgress={setProgress} />
    </PageTemplate>
  );
};

export default GrammarPage;
